import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button
} from '@mui/material'

const TaskOptionDialog = ({
  open,
  taskType,
  totalCount = 0,
  alreadyProcessedCount = 0,
  onForceAll,
  onRemoveProcessed,
  onCancel
}) => {
  const { t } = useTranslation()
  const remainingCount = totalCount - alreadyProcessedCount

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {t('mailTemplate.campaigns.dashboard.taskOption.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(`mailTemplate.campaigns.dashboard.taskOption.message_${taskType}`, { totalCount, alreadyProcessedCount })}
        </DialogContentText>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 3, ml: 0.5, pb: 4, pt: 1 }}>
        <Button onClick={onCancel} color="error" variant="outlined" sx={{ borderRadius: 2 }}>
          {t('mailTemplate.campaigns.dashboard.taskOption.cancel')}
        </Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button onClick={onForceAll} color="primary" variant="outlined" sx={{ borderRadius: 2 }}>
            {t(`mailTemplate.campaigns.dashboard.taskOption.forceAll_${taskType}`, { count: totalCount })}
          </Button>
          <Button onClick={onRemoveProcessed} color="primary" variant="contained" sx={{ borderRadius: 2 }} autoFocus disabled={remainingCount <= 0}>
            {t(`mailTemplate.campaigns.dashboard.taskOption.removeProcessed_${taskType}`, { count: remainingCount })}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default TaskOptionDialog
